import { render } from "./ArrowMenuRight.vue?vue&type=template&id=01849992"
import script from "./ArrowMenuRight.vue?vue&type=script&lang=js"
export * from "./ArrowMenuRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__